export const sentryHandoffErrorIgnoreList = [
  'window.zE is undefined or Zendesk Messaging iframe is not found',
  'window.fcWidget is not found',
  'Salesforce chat button is not found',
  'window.embedded_svc is undefined',
  'window.embeddedservice_bootstrap is undefined',
  'window.zE is undefined',
  'window.Kustomer is undefined',
  'Failed to create Kustomer conversation',
  'Salesforce One Chat handoff error',
  'window.SnapEngage is undefined, or is missing necessary functions',
  'All departments are offline',
  'Department is offline',
];
